module.exports = __webpack_public_path__ + "static/media/plat.eb6ebc57.mp4";